/**
 * Tipos dos Recursos Administrativos do Portal do Credenciado.
 *
 * Recurso administrativo é a defesa que o credenciado protocola contra uma
 * multa ou outra penalidade aplicada pela SMT. Sem
 * `docs/MODELO-DE-DADOS.md` para esta tabela ainda (não existe no banco): os
 * campos aqui nascem do protótipo e do bom senso, não de migração.
 */

export type StatusDoRecurso = 'em_analise' | 'deferido' | 'indeferido' | 'em_recurso_superior';

/** Categoria fechada do que está sendo contestado — `referencia` continua sendo o texto livre do caso concreto. */
export type TipoDeRecurso = 'multa' | 'glosa' | 'penalidade' | 'outro';

export const ROTULO_DO_TIPO_DE_RECURSO: Record<TipoDeRecurso, string> = {
  multa: 'Multa',
  glosa: 'Glosa',
  penalidade: 'Penalidade',
  outro: 'Outro',
};

export interface RecursoAdministrativo {
  id: string;
  /** Número do processo, ex. "REC-2026/00042". */
  numero_processo: string;
  tipo: TipoDeRecurso;
  /** O que está sendo contestado, ex. "Multa MUL-2026-0031 — atraso de partida". */
  referencia: string;
  /** Data de protocolo, formato ISO ("2026-06-02"). */
  data_protocolo: string;
  /**
   * Prazo legal de resposta, formato ISO. Só é relevante — e só aparece na
   * tela — enquanto o recurso está "vivo" (`status === 'em_analise'`).
   */
  prazoResposta: string;
  status: StatusDoRecurso;
  /** Texto do desfecho, quando o recurso já foi decidido. `null` enquanto está em análise. */
  decisao: string | null;
}

/** Filtro da listagem de recursos. A paginação é sempre do servidor. */
export interface FiltroDeRecursos {
  pagina: number;
  tamanho: number;
  /** Texto livre, combina com `referencia` ou `numero_processo`. */
  busca?: string;
  status?: StatusDoRecurso;
  /** Data de protocolo inicial, formato ISO. */
  protocoloDe?: string;
  /** Data de protocolo final, formato ISO. */
  protocoloAte?: string;
}

export const TAMANHO_PAGINA_PADRAO = 10;
